import { Loader } from 'semantic-ui-react';
import { Container } from './styles';

export default function PageLoader() {
  return (
    <Container>
      <Loader active size="massive" />
    </Container>
  );
}